import {isFunction, isEqual} from 'lodash';

function functionExistenceValidator(instance, functionName) {
    if (!instance[functionName] || !isFunction(instance[functionName])) {
        throw new Error(`A "${functionName}" function should exist`);
    }
}

function truthyValueReturnedValidator(instance, functionName, fieldName) {
    if (!instance[functionName]()) {
        throw new Error(`"${fieldName}" must be defined`);
    }
}

function validateTierImplementation(tier) {
    functionExistenceValidator(tier, 'getId');
    functionExistenceValidator(tier, 'getStyle');
    functionExistenceValidator(tier, 'getPosition');

    truthyValueReturnedValidator(tier, 'getId', 'id');
    truthyValueReturnedValidator(tier, 'getPosition', 'position');
}

class TierProxy {
    constructor(tierImplementation) {
        validateTierImplementation(tierImplementation);
        this.impl = tierImplementation;
        this.visible = this.impl.isVisible ? this.impl.isVisible() : true;
        this._proxy = true;
        this.beforeLayerIds = [];
    }

    getId = () => this.impl.getId();

    getStyle = () => this.style ? this.style : this.impl.getStyle();

    setStyle = (style) => {
        if (this.impl.setStyle) {
            this.impl.setStyle(style);
        } else {
            this.style = style;
        }
    };

    getPosition = () => this.impl.getPosition();

    isVisible = () => {
        if (this.impl.isVisible) {
            return this.impl.isVisible();
        } else {
            return this.visible;
        }
    };

    setVisible = (visible) => {
        if (this.impl.setVisible) {
            this.impl.setVisible(visible);
        } else {
            this.visible = visible;
        }
    };

    onBeforeAdd = (map) => {
        if (this.impl.onBeforeAdd) {
            return Promise.resolve(this.impl.onBeforeAdd(map));
        }

        return Promise.resolve();
    };

    onAdd = (tiersPainter) => {
        if (this.impl.onAdd) {
            return Promise.resolve(this.impl.onAdd(tiersPainter));
        }

        return Promise.resolve();
    };

    onRemove = (tiersPainter) => {
        if (this.impl.onRemove) {
            return Promise.resolve(this.impl.onRemove(tiersPainter));
        }

        return Promise.resolve();
    };

    setLanguage = async (language) => {
        if (this.impl.setLanguage) {
            return Promise.resolve(this.impl.setLanguage(language));
        }

        return Promise.resolve(false);
    };

    setGeopoliticalView = async (geopoliticalView) => {
        if (this.impl.setGeopoliticalView) {
            return Promise.resolve(this.impl.setGeopoliticalView(geopoliticalView));
        }

        return Promise.resolve(false);
    };

    setBeforeLayerIds = (beforeLayerId) => {
        this.beforeLayerIds = beforeLayerId;
    };

    getBeforeLayerIds = () => this.beforeLayerIds;

    getUrlTransformer = () => {
        if (this.impl.getUrlTransformer) {
            return this.impl.getUrlTransformer();
        }

        return null;
    };

    isRaster = () => {
        if (this.impl.isRaster) {
            return this.impl.isRaster();
        }
        return false;
    };

    needsUpdate = (currentOptions) => {
        return !isEqual(this.impl.getOptions(), currentOptions);
    };
}

export default (tierImplementation) => {
    if (!tierImplementation) {
        throw new Error('Tier has to be defined.');
    }
    if (tierImplementation._proxy) {
        return tierImplementation;
    }
    return new TierProxy(tierImplementation);
};



// WEBPACK FOOTER //
// ./map/tier/tierProxy.js